var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIkonaSzukaj(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.517,
    height: 22.574,
    viewBox: "0 0 22.517 22.574"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#750b22"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 39",
    d: "M17.865 14.58l4.074 4.074a1.991 1.991 0 010 2.807l-.48.48-.037.035a2.013 2.013 0 01-1.269.6 1.683 1.683 0 01-1.323-.527l-4.205-4.207a9.622 9.622 0 113.245-3.262zm-2.221 2.545l4.055 4.053a.5.5 0 00.38.169.815.815 0 00.483-.251l.505-.506a.754.754 0 000-1.066l-3.915-3.916a8.986 8.986 0 01-.728.817 9.29 9.29 0 01-.779.7zM9.619 1.28a8.344 8.344 0 11-5.9 2.443 8.31 8.31 0 015.9-2.443z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 40",
    d: "M9.625 3.793a5.838 5.838 0 11-5.838 5.838 5.844 5.844 0 015.838-5.838m0-1.126a6.963 6.963 0 106.963 6.964 6.963 6.963 0 00-6.963-6.964z"
  }))));
}

export default SvgIkonaSzukaj;